// extracted by mini-css-extract-plugin
export default {"icon":"styles_icon__HmsHs","circle":"styles_circle__2Z4r3","profpic":"styles_profpic__v+2Gy","small":"styles_small__4OicX","large":"styles_large__IWm2b"};